module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [(_vm.auditFlowInfo) ? _c('div', {
    staticClass: "auditFlow"
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.auditFlowInfo.stepIndex,
      "finish-status": "success"
    }
  }, _vm._l((_vm.auditFlowInfo.auditSteps), function(item, index) {
    return _c('el-step', {
      key: index,
      attrs: {
        "title": item.title,
        "description": item.desc,
        "status": item.status
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    style: ({
      marginBottom: _vm.marginBottomHeight + 'px'
    })
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryForm.state),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "state", $$v)
      },
      expression: "queryForm.state"
    }
  }, _vm._l((_vm.comboData.state), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray",
      "size": "medium"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray",
      "size": "medium"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "信息加载中",
      "cell-style": _vm.handleCellStyle,
      "highlight-current-row": "",
      "stripe": "",
      "border": "",
      "fit": "",
      "height": _vm.mainTableHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "审核层级",
      "prop": "auditLevel",
      "align": "center",
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核状态",
      "prop": "auditState",
      "align": "center",
      "min-width": "15%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核意见",
      "prop": "opinion",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核人",
      "prop": "auditor",
      "align": "center",
      "min-width": "18%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核时间",
      "prop": "auditTime",
      "align": "center",
      "min-width": "18%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "state",
      "align": "center",
      "min-width": "12%"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-790d9b8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/audit/auditList.vue
// module id = 1870
// module chunks = 502